import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import * as z from "zod";
import { canUnflagReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

const BulkUnflagPayloadSchema_ = z.object({});
export interface UnflagPayload extends z.infer<
  typeof BulkUnflagPayloadSchema_
> {}

/** Undoes flag: the return goes back to the status its shipments imply. */
export const unflagReturnAction = defineReturnAction<UnflagPayload>({
  label: "Unflag",
  permissions: [ReturnsAndClaimsPermissions.FLAG_RETURN],
  isEligible: ({ return_ }) => canUnflagReturn({ return_ }),
  payloadSchema: BulkUnflagPayloadSchema_,
  examplePayload: {},
});
